import Seo from "../components/Seo";

const Section = ({ title, children }) => (
  <div className="mt-8">
    <h2 className="font-display text-xl font-extrabold text-brand-navy">{title}</h2>
    <div className="mt-2 space-y-3 text-brand-muted leading-relaxed">{children}</div>
  </div>
);

export default function Privacy() {
  return (
    <>
      <Seo title="Privacy Policy | Car To Cash" description="How Car To Cash collects, stores and uses your personal information in line with the Australian Privacy Act." canonical="https://cartocash.com.au/privacy" />
      <section className="mx-auto max-w-3xl px-4 sm:px-6 py-16" data-testid="privacy-page">
        <h1 className="font-display text-4xl font-black text-brand-navy">Privacy Policy</h1>
        <p className="mt-3 text-sm text-brand-muted">Last updated: {new Date().toLocaleDateString("en-AU", { year: "numeric", month: "long", day: "numeric" })}</p>

        <Section title="Who we are">
          <p>Car To Cash ("we", "us", "our") buys vehicles for cash across Melbourne and regional Victoria. We are committed to protecting your privacy in accordance with the Australian Privacy Act 1988 (Cth) and the Australian Privacy Principles (APPs).</p>
        </Section>
        <Section title="Information we collect">
          <p>When you request a quote, contact us, request a callback or subscribe, we may collect your name, phone number, email address, suburb or postcode, vehicle details (make, model, year, registration, kilometres, condition, finance and accident history), and any photos you upload. We also collect basic analytics data such as pages viewed and form interactions.</p>
        </Section>
        <Section title="How we use your information">
          <p>We use your information to provide a valuation, arrange an inspection, complete a purchase, respond to enquiries, and improve our service. We may contact you by phone, SMS or email about your enquiry.</p>
        </Section>
        <Section title="How we store and protect it">
          <p>Your data is stored securely in an encrypted database. Access is restricted to authorised staff. Sensitive credentials such as API keys and access tokens are encrypted at rest. We retain lead information only as long as necessary for the purposes above or as required by law, and we perform regular backups.</p>
        </Section>
        <Section title="Disclosure">
          <p>We do not sell your personal information. We may share information with service providers who help us operate (for example, email delivery), and where required by law.</p>
        </Section>
        <Section title="Cookies">
          <p>We use cookies and similar technologies to run the site, remember your preferences and measure performance (including Google Analytics). You can control cookies through your browser settings and via our cookie banner.</p>
        </Section>
        <Section title="Your rights">
          <p>You may request access to, or correction of, the personal information we hold about you, or ask us to delete it, by emailing <a href="mailto:info@cartocash.com.au" className="font-semibold text-brand-navy underline">info@cartocash.com.au</a>. You may also complain if you believe we have breached the APPs.</p>
        </Section>
        <Section title="Contact">
          <p>Car To Cash — 0431 206 206 — info@cartocash.com.au</p>
        </Section>
      </section>
    </>
  );
}
